import { render, staticRenderFns } from "./FeedbackCofenReport.vue?vue&type=template&id=af2225ba&scoped=true"
import script from "./FeedbackCofenReport.vue?vue&type=script&lang=js"
export * from "./FeedbackCofenReport.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCofenReport.vue?vue&type=style&index=0&id=af2225ba&prod&scoped=true&lang=css"
import style1 from "./FeedbackCofenReport.vue?vue&type=style&index=1&id=af2225ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2225ba",
  null
  
)

export default component.exports